<template>
  <div class="theme-content">
    <!-- <div class="form-box">
      <form
        id="cgForm"
        action="http://202.120.227.56:8331/V"
        method="get"
        target="_blank"
      >
        <input name="func" value="find-db-1-lcl" type="hidden" />
        <input name="func" value="quick-1-check1-lcl" type="hidden" />
        <input name="mode" value="simple" type="hidden" />
        <input id="group_number" name="group_number" v-model="curSearchWay" />
        <input name="find_request_1" v-model="searchValue" />
      </form>
    </div> -->

    <div class="block-search">
      <div class="image-text_2">
        <div class="section_8 flex-row">
          <span class="search-condtion">{{ getNameById(curSearchWay) }}</span>
          <img class="search-way-icon" referrerpolicy="no-referrer" src="../../../assets/search-way.png" />
          <div class="show-select-condtion">
            <div v-for="item in searchWay" :class="curSearchWay == item.value ? 'selected-item' : ''" :key="item.value"
              @click="selectWayItem(item.value)">
              <div class="show-select-item">{{ item.name }}</div>
            </div>
          </div>
        </div>
        <div class="search-input-box">
          <input type="input" @keyup.enter="searchSubmit" v-model="searchValue" placeholder="根据选择条件输入相应的搜索值"
            class="search-input" />
        </div>
        <div class="search-bnt search-bnt1 flex-col" @click="searchSubmit()">
          <span>搜索</span>
        </div>
      </div>
    </div>
    <img class="image_4" referrerpolicy="no-referrer" src="../../../assets/search-input-bg.png" />
    <div class="theme-info">{{ info }}</div>
  </div>
</template>

<script>
const urls = [
  "https://book.duxiu.com/search?Field=all&channel=search&ecode=utf-8&edtype=&searchtype=&view=0&sw=", // 中文跳转地址
  "https://opac.fudan.edu.cn/?func=find-b&adjacent=Y&find_code=WRD&local_base=FDU09&filter_code_1=WFM&filter_request_1=CF&request=", // 外文跳转地址
];
export default {
  name: "",
  components: {},
  props: {},
  data () {
    return {
      showForm: false,
      drawer: false,
      themeId: 1,
      searchValue: "",
      id: 2,
      name: "文献查找",
      curSearchWay: 0,
      searchWay: [
        { value: 0, name: "中文" },
        { value: 1, name: "外文" },
      ],
      info: "说明：查找您需要的电子图书。",
    };
  },
  watch: {
    $route: {
      handler (to) {
        this.isPosition = to.path === "/home";
      },
      immediate: true,
    },
  },
  computed: {
    currentPath () {
      return this.$route.path;
    },
  },
  methods: {
    selectWayItem (value) {
      this.curSearchWay = value;
    },
    getNameById (value) {
      const record = this.searchWay;
      const data = record.find((item) => item.value === value);
      return data.name;
    },
    searchSubmit () {
      if (this.searchValue) {
        // let form = document.getElementById("cgForm");
        // form.submit();
        const url = urls[this.curSearchWay] + this.searchValue;
        window.open(url);
      }
    },
  },
  mounted () { },
};
</script>

<style scoped lang="scss">
.form-box {
  display: none;
}

.block-search {
  // width: 1228px;
  // margin: 19px 0 0 133px;
  margin-top: 30px;
  height: 58px;
  background: #fff;

  .section_8 {
    background-color: rgba(0, 72, 150, 1);
    width: 157px;
    height: 57px;
    position: relative;
    cursor: pointer;
  }

  .section_8:hover .show-select-condtion {
    display: block;
    z-index: 999;
  }

  .search-way-icon {
    width: 15px;
    height: 6px;
    margin: 28px 13px 0 30px;
  }

  .search-condtion {
    width: 100px;
    height: 22px;
    overflow-wrap: break-word;
    color: rgba(255, 255, 255, 1);
    text-align: right;
    white-space: nowrap;
    line-height: 33px;
    margin: 14px 0 0 0;
    padding: 0px 6px;
    font-size: 18px;
    font-weight: 700;
  }

  .show-select-condtion {
    width: 157px;
    position: absolute;
    top: 58px;
    display: none;
    max-height: 260px;
    overflow-y: auto;
    background-color: rgba(0, 72, 150, 1);
    color: #fff;

    .show-select-item {
      padding: 10px 6px;
      border-bottom: 1px solid #fff;
    }

    .selected-item {
      background: rgba(255, 255, 255, 0.2);
    }
  }

  .search-input-box {
    flex: 1;

    .search-input {
      // width: 800px;
      width: 100%;
      height: 58px;
      line-height: 58px;
      background: 0 0;
      font-size: 16px;
      letter-spacing: 0;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      padding: 0;
      border: 0;
      outline: 0;
      padding-left: 20px;
    }
  }
}

.image-text_2 {
  display: flex;
  align-items: center;
  padding-right: 20px;
}

.search-bnt {
  height: 48px;
  line-height: 48px;
  text-align: center;
  color: rgba(255, 255, 255, 1);
  font-size: 18px;
  font-weight: 900;
  border-radius: 5px;
  cursor: pointer;
}

.search-bnt1 {
  background-color: rgba(236, 108, 0, 1);
  width: 106px;
  margin-left: auto;
}

.image_4 {
  position: relative;
  // width: 1057px;
  width: 100%;
  height: 2px;
  top: -10px;
  // margin: -10px 0 0 303px;
}

.theme-info {
  width: 612px;
  color: rgba(51, 51, 51, 1);
  font-size: 14px;
  text-align: left;
  line-height: 26px;
  // margin: 0px 0 310px 305px;
}
</style>
